export const CLIENT_TYPES = {
  MARKET_RESEARCH: "Quantitative Data Collection",
  MARKET_RESEARCH_FULL_SERVICE:"Quantitative + Qualitative + Desk Research",
  // CONSULTING: "Consulting",
  // AD_AGENCY: "Ad Agency",
  // END_CLIENTS: "End Clients"
}

export const clientTypesEnum = Object.getOwnPropertyNames(CLIENT_TYPES).map(key => CLIENT_TYPES[key])


export const CLIENT_INDUSTRY = {
  AEROSPACE_AND_DEFENSE: "Aerospace & Defense",
  AGRICULTURE: "Agriculture",
  AUTOMOTIVE_AND_TRANSPORTATION: "Automotive & Transportation",
  BANKING_AND_FINANCE: "Banking & Finance",
  BUSINESS_AND_PROFESSIONAL_SERVICES: "Business & Professional Services",
  CHEMICAL: "Chemical",
  CONSTRUCTION_AND_BUILDING_MATERIALS: "Construction & Building Materials",
  CONSUMER_DURABLES: "Consumer Durables",
  CONSUMER_PACKAGED_GOODS: "Consumer Packaged Goods",
  EDUCATION: "Education",
  HEALTHCARE: "Healthcare",
  HOSPITALITY: "Hospitality",
  INSURANCE: "Insurance",
  MANUFACTURING: "Manufacturing",
  MINING: "Mining",
  PHARMACEUTICAL_AND_BIOTECH: "Pharmaceutical & Biotech",
  PUBLIC_SECTOR_AND_GOVERNMENT: "Public sector & Government",
  REAL_ESTATE: "Real Estate",
  REPAIR_AND_MAINTENANCE: "Repair & Maintenance",
  RETAIL: "Retail",
  TECHNOLOGY: "Technology",
  TELECOMMUNICATIONS: "Telecommunications",
  UTILITIES_AND_ENERGY: "Utilities & Energy",
  WHOLESALE: "Wholesale",
}

export const clientIndustryEnum = Object.getOwnPropertyNames(CLIENT_INDUSTRY).map(key => CLIENT_INDUSTRY[key])